import React from "react"

const TermsOfService = () => {
  return (
    null
  )
}

export default TermsOfService;